export const activityTypes = {
  // Standard activity
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  UPDATED: 'UPDATED',
  CLONED: 'CLONED',
  CLONED_FROM: 'CLONED_FROM',
  RENAMED: 'RENAMED',
  // Comment
  COMMENTED: 'COMMENTED',
  COMMENT_RESOLVED: 'COMMENT_RESOLVED',
  COMMENT_UNRESOLVED: 'COMMENT_UNRESOLVED',
  COMMENT_UPDATED: 'COMMENT_UPDATED',
  COMMENT_DELETED: 'COMMENT_DELETED',
  // Approval
  APPROVAL_REQUESTED: 'APPROVAL_REQUESTED',
  APPROVAL_APPROVED: 'APPROVAL_APPROVED',
  APPROVAL_CANCELLED: 'APPROVAL_CANCELLED',
  APPROVAL_REJECTED: 'APPROVAL_REJECTED',
  // Manage access
  ADDED_ACCESS: 'ADDED_ACCESS',
  REMOVED_ACCESS: 'REMOVED_ACCESS',
  // Move to folder
  MOVED: 'MOVED',
  // Object association
  ASSOCIATED: 'ASSOCIATED',
  DISASSOCIATED: 'DISASSOCIATED',
  // AB test
  CREATED_AB_TEST: 'CREATED_AB_TEST',
  CREATED_PART_OF_AB: 'CREATED_PART_OF_AB',
  // Non standard activity
  ARCHIVED: 'ARCHIVED',
  UNARCHIVED: 'UNARCHIVED',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  TURNED_ON: 'TURNED_ON',
  TURNED_OFF: 'TURNED_OFF',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  CONVERTED_TO_DRAFT: 'CONVERTED_TO_DRAFT',
  CANCELLED: 'CANCELLED',
  UNCANCELLED: 'UNCANCELLED'
};
export const COMMENT_ACTIVITY_TYPES = ['COMMENTED', 'COMMENT_UPDATED', 'COMMENT_RESOLVED', 'COMMENT_UNRESOLVED', 'COMMENT_DELETED'];
export const updateActivityTypes = {
  // Campaign update
  UPDATED: 'UPDATED'
};
export const VIRTUAL_COMMENT_TYPES = {
  REPLIED: 'REPLIED',
  REPLY_DELETED: 'REPLY_DELETED',
  REPLY_UPDATED: 'REPLY_UPDATED'
};
// LANDING_PAGE, MARKETING_EMAIL, SITE_PAGE, and BLOG_POST
export const CONTENT_TYPES = ['0-25', '0-29', '0-38', '0-39'];
export const APPROVAL_TYPES = ['APPROVAL_REQUESTED', 'APPROVAL_APPROVED', 'APPROVAL_CANCELLED', 'APPROVAL_REJECTED'];